import PropTypes from 'prop-types';
import React from 'react';

import ProfileImageCircles from 'pages/common/components/ProfileImageCircles/ProfileImageCircles';

import {
  ContentWrapper,
  InstantBookIcon,
  JustifySelfRight,
  OptionText,
} from './styled-components';

export const OptionContent = ({ images, localImages, text, isInstantBook }) => (
  <ContentWrapper>
    {(images?.length > 0 || localImages?.length > 0) 
      && (
        <ProfileImageCircles
          images={images}
          localImages={localImages}
          marginRight="-5px"
          height="24px"
          width="24px"
          presentationOnly
        />
      )
    }
    <OptionText>{text}</OptionText>
    {isInstantBook 
      && (
        <JustifySelfRight>
          <InstantBookIcon theme="filled" type="thunderbolt" />
        </JustifySelfRight>
      )
    }
  </ContentWrapper>
);

OptionContent.propTypes = {
  images: PropTypes.array,
  localImages: PropTypes.array,
  text: PropTypes.string,
  isInstantBook: PropTypes.bool,
};
